import React from 'react';
import classNames from 'classnames';

const DetailTable = ({ rows, slug }) =>  {
  let tbody = '';
  if(typeof(rows) !== 'undefined'){
    tbody = rows.map((row, i) => {
      return (
        <tr key={i}>{row.map((data, i) => <td key={i}>{data}</td>)}</tr>
      )
    });
  }
  // table headers different for Raffle ticket
  return (
    <table className="scene__table">
        <thead>
            <tr>
                <th>{slug === 'raffle' ? 'Prize' : 'Prize Amount'}</th>
                <th>{slug === 'raffle' ? 'Quantity' : 'Winning Tickets'}</th>
                <th>{slug === 'raffle' ? 'Odds' : 'Unclaimed'}</th>
            </tr>
        </thead>
        <tbody>
          {tbody}
        </tbody>
    </table>
  );
}

export default DetailTable;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Detail/DetailTable.js
 **/